import React, { useEffect, useState } from "react";
import styles from "../../styles/dashboard/environment.module.css";
import DashboardCard from "../Common/DashboardCard";
import LineChart from "../GraphNCharts/LineChart";
import { monthSort } from "../../utils/constant";
import { get } from "../../utils/api";
import EchartDoughnutChart from "../GraphNCharts/EchartDoughnut";
import PieChart from "../GraphNCharts/Pie";
import {
  fixedPercentage,
  fixedTons,
  formatNumberCommaSeparated,
} from "../../utils/common";
import { Typography } from "@mui/material";
import NoDataFound from "../Masters/NoDataFound";
import { useUser } from "../../context/AuthContext";
import useAuthStore from "../../store/ContextUser";
const Environment = ({ currentYear }) => {
  const { user } = useUser();
  const { selectedCompany } = useAuthStore();
  const [emissionType, setEmissionType] = useState("Annual");
  const [ghgTotal, setGhgTotal] = useState({});

  const [dashboardData, setDashboardData] = useState({
    waterUsage: null,
    waterIntensity: null,
    waterDiversion: null,
    ghgbaselineData: null,
  });

  const [overviewData, setOverviewData] = useState({
    scope1: null,
    scope2: null,
    scope3: null,
  });

  const overviewApiUrls = {
    scope1: `/dashboard/enviornment/overview/scope1?companyId=${selectedCompany?._id}`,
    scope2: `/dashboard/enviornment/overview/scope2?companyId=${selectedCompany?._id}`,
    scope3: `/dashboard/enviornment/overview/scope3?companyId=${selectedCompany?._id}`,
  };

  const apiurls = {
    dashboard: `/dashboard/enviornment/overview?baseYear=${
      currentYear ? "baseline" : null
    }&companyId=${selectedCompany?._id}`,
    ghgbaseline: `/dashboard/enviornment/ghg/baseline?companyId=${selectedCompany?._id}`,
  };

  const fetchData = async () => {
    try {
      const [dashboard, ghgbaseline] = await Promise.all([
        get(apiurls.dashboard),
        get(apiurls.ghgbaseline),
      ]);
      setDashboardData({
        waterUsage: dashboard?.data?.waterUsageData,
        waterIntensity: dashboard?.data?.waterIntensity,
        waterDiversion: dashboard?.data?.wasterDiversionRate,
        ghgbaselineData: ghgbaseline?.data?.data,
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentYear, selectedCompany]);

  const fetchOverviewData = async () => {
    try {
      const [scope1, scope2, scope3] = await Promise.all([
        get(overviewApiUrls.scope1),
        get(overviewApiUrls.scope2),
        get(overviewApiUrls.scope3),
      ]);
      setOverviewData({
        scope1: scope1?.data?.environmentDashboardRes,
        scope2: scope2.data?.environmentDashboardRes,
        scope3: scope3.data,
      });
      setGhgTotal({
        oneYearTotal: fixedTons(
          (scope1?.data?.environmentDashboardRes?.scopoe1MonthlEmission?.data?.reduce(
            (acc, i) => acc + (i || 0),
            0
          ) || 0) +
            (scope2?.data?.environmentDashboardRes?.scope2MontlyEmission?.reduce(
              (acc, i) => acc + (i.finalEmission || 0),
              0
            ) || 0) +
            (scope3?.data?.scope3Emission?.totalSum?.reduce(
              (acc, i) => acc + (i || 0),
              0
            ) || 0)
        ),
        tenYearTotal: fixedTons(
          (scope1?.data?.environmentDashboardRes?.scope1Last10YearData?.reduce(
            (acc, i) => acc + (i.totalEmission || 0),
            0
          ) || 0) +
            (scope2?.data?.environmentDashboardRes?.last10yearScope2FinalEmission?.reduce(
              (acc, i) => acc + (i.finalEmission || 0),
              0
            ) || 0) +
            (scope3?.data?.scope3Last10YearData?.last10yearsum?.reduce(
              (acc, i) => acc + (i || 0),
              0
            ) || 0)
        ),
      });
    } catch (error) {
      setOverviewData({
        scope1: null,
        scope2: null,
        scope3: null,
      });
    }
  };

  useEffect(() => {
    if (user?._id !== "undefined" || user?._id !== null || user !== undefined) {
      fetchOverviewData();
    }
  }, [user, selectedCompany]);

  let annualdataset = [
    overviewData?.scope1?.scopoe1MonthlEmission?.data?.filter(Boolean)?.length >
    0
      ? {
          label: "Scope 1",
          data: overviewData?.scope1?.scopoe1MonthlEmission?.data ?? [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          borderColor: "rgba(255, 68, 68, 1)",
          backgroundColor: "rgba(255, 68, 68, 1)",
          tension: 0.4,
          fill: true,
          pointRadius: 0,
        }
      : "",
    overviewData?.scope2?.scope2MontlyEmission
      ?.map((item) => item?.finalEmission)
      ?.filter(Boolean)?.length > 0
      ? {
          label: "Scope 2",
          data: overviewData?.scope2?.scope2MontlyEmission?.map(
            (item) => item?.finalEmission
          ) ?? [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          borderColor: "rgba(255, 187, 51, 1)",
          backgroundColor: "rgba(255, 187, 51, 1)",
          tension: 0.4,
          fill: true,
          pointRadius: 0,
        }
      : "",
    overviewData?.scope3?.scope3Emission
      ?.map((item) => item?.totalEmission)
      ?.filter(Boolean)?.length > 0
      ? {
          label: "Scope 3",
          data: overviewData?.scope3?.scope3Emission?.map(
            (item) => item?.totalEmission
          ) ?? [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          borderColor: "rgba(0, 102, 231, 1)",
          backgroundColor: "rgba(0, 102, 231, 1)",
          tension: 0.4,
          fill: true,
          pointRadius: 0,
        }
      : "",
  ].filter(Boolean);

  let yoydataset = [
    overviewData?.scope1?.scope1Last10YearData
      ?.map((item) => item?.totalEmission)
      ?.filter(Boolean)?.length > 0
      ? {
          label: "Scope 1",
          data: overviewData?.scope1?.scope1Last10YearData?.map(
            (item) => item?.totalEmission
          ) ?? [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          borderColor: "rgba(255, 68, 68, 1)",
          backgroundColor: "rgba(255, 68, 68, 1)",
          tension: 0.4,
          fill: true,
          pointRadius: 0,
        }
      : "",
    overviewData?.scope2?.last10yearScope2FinalEmission
      ?.map((item) => item?.finalEmission)
      ?.filter(Boolean)?.length > 0
      ? {
          label: "Scope 2",
          data: overviewData?.scope2?.last10yearScope2FinalEmission?.map(
            (item) => item?.finalEmission
          ) ?? [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          borderColor: "rgba(255, 187, 51, 1)",
          backgroundColor: "rgba(255, 187, 51, 1)",
          tension: 0.4,
          fill: true,
          pointRadius: 0,
        }
      : "",
    overviewData?.scope3?.scope3Last10YearData
      ?.map((item) => item?.totalEmission)
      ?.filter(Boolean)?.length > 0
      ? {
          label: "Scope 3",
          data: overviewData?.scope3?.scope3Last10YearData?.map(
            (item) => item?.totalEmission
          ) ?? [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          borderColor: "rgba(0, 102, 231, 1)",
          backgroundColor: "rgba(0, 102, 231, 1)",
          tension: 0.4,
          fill: true,
          pointRadius: 0,
        }
      : "",
  ]?.filter(Boolean);

  let stationaryEmissionLabels = [
    dashboardData?.ghgbaselineData?.ghgBaselineData?.scope1?.value
      ? {
          color: "#FFBB33",
          label: "Scope 1",
          value: Math.round(
            dashboardData?.ghgbaselineData?.ghgBaselineData?.scope1?.value
          ),
        }
      : "",
    dashboardData?.ghgbaselineData?.ghgBaselineData?.scope2?.value
      ? {
          color: "#000000",
          label: "Scope 2",
          value: Math.round(
            dashboardData?.ghgbaselineData?.ghgBaselineData?.scope2?.value
          ),
        }
      : "",
    dashboardData?.ghgbaselineData?.ghgBaselineData?.scope3?.value
      ? {
          color: "#0066E7",
          label: "Scope 3",
          value: Math.round(
            dashboardData?.ghgbaselineData?.ghgBaselineData?.scope3?.value
          ),
        }
      : "",
  ].filter(Boolean);

  const ghgBaselinetotal = fixedTons(
    stationaryEmissionLabels?.reduce((acc, i) => acc + i?.value, 0)
  );

  const vehicleEmissionData = [
    {
      data: [30, 70],
      backgroundColor: ["#0066E7", "#BCBCBC"],
      borderColor: "#fff",
      borderWidth: 0,
      offset: [0, 15],
    },
  ];

  return (
    <div className={styles.pageContainer}>
      {/* Metrics Section */}
      {currentYear ? (
        <>
          <div
            className={styles.metricsSection}
            style={{ marginBottom: "1.2rem", width: "102%", marginLeft: "-1%" }}
          >
            <DashboardCard
              title={"Water Usage"}
              subHeading={"Water Reused / recycled"}
              value={dashboardData?.waterUsage?.totalWaterWithdrawal ?? 0}
              unit={" KL"}
              subHeading1={"Total Water Withdrawal"}
              subvalue={dashboardData?.waterUsage?.waterUsage ?? 0}
              subUnit={" KL"}
            />

            <DashboardCard
              title={"Energy Intensity"}
              subHeading={"Energy consumption relative to production output."}
              value={`${formatNumberCommaSeparated(
                fixedTons(
                  dashboardData?.ghgbaselineData?.energyIntensity
                    ?.energyIntensity?.value ?? 0
                )
              )} MWh/unit`}
            />

            <DashboardCard
              title={"Waste Diversion Rate"}
              subHeading={
                "Percentage of waste diverted from landfills through recycling or reuse."
              }
              value={`${
                fixedPercentage(
                  dashboardData?.ghgbaselineData?.waste
                    ?.wasteDivertedFromLandFill?.value
                ) ?? 0
              } %`}
            />
          </div>
          <div
            className={styles.cards_container_div}
            style={{ width: "102%", marginLeft: "-1%" }}
          >
            <div className={styles.cards_container}>
              <p className={styles.graph_heading}>
                Total GHG Emissions (tCO2e):{" "}
                <span className={styles.graph_span}>
                  {formatNumberCommaSeparated(ghgBaselinetotal) || 0}
                </span>
              </p>
              <div className={styles.chart_div}>
                <EchartDoughnutChart
                  labels={stationaryEmissionLabels?.map((el) => el?.label)}
                  dataPoints={stationaryEmissionLabels?.map((el) =>
                    fixedTons(el?.value)
                  )}
                  colors={stationaryEmissionLabels?.map((el) => el?.color)}
                  legendPosition="top"
                  customWidth={"150px"}
                  customHeight={"150px"}
                  hide={true}
                />
                <div className={styles.doughnut_table_div}>
                  {stationaryEmissionLabels?.length > 0 ? (
                    stationaryEmissionLabels.map((item, index) => (
                      <div key={index} className={styles.table_container}>
                        <div className={styles.table_row}>
                          <span
                            className={styles.table_row_label}
                            style={{
                              backgroundColor: item.color,
                            }}
                          ></span>
                          <span className={styles.table_text}>
                            {item.label}
                          </span>
                        </div>
                        <span className={styles.table_text}>
                          {formatNumberCommaSeparated(item?.value)}
                        </span>
                      </div>
                    ))
                  ) : (
                    <NoDataFound />
                  )}
                </div>
              </div>
            </div>
            <div className={styles.cards_container}>
              <p className={styles.graph_heading}>
                Renewable Energy Consumption:
                <span className={styles.graph_span}>30%</span>
              </p>
              <PieChart
                labels={["Our Consumption", "Industry Benchmark"]}
                dataset={vehicleEmissionData}
                customWidth={150}
                customHeight={150}
                color={["#0066E7", "#BCBCBC"]}
              />
            </div>
          </div>
        </>
      ) : (
        <>
          <div
            className={styles.metricsSectionYear}
            style={{ width: "102%", marginLeft: "-1%" }}
          >
            <DashboardCard
              title={"Water Usage"}
              subHeading={"Water Reused / recycled"}
              value={fixedPercentage(
                dashboardData?.waterUsage?.waterUsage ?? 0
              )}
              unit=" KL"
              subHeading1={"Total Water Withdrawl"}
              subvalue={fixedPercentage(
                dashboardData?.waterUsage?.totalWaterWithdrawal ?? 0
              )}
              subUnit=" KL"
              subchangeValue={`${fixedPercentage(
                dashboardData?.waterUsage?.percentage ?? 0
              )}%`}
              subchange={
                (dashboardData?.waterUsage?.percentage ?? 0) > 0
                  ? "increase"
                  : "decrease"
              }
            />

            {/* <DashboardCard
              title={"Energy Intensity"}
              subHeading={"Energy consumption relative to production output."}
              value={"0 MWh/unit"}
              changeValue={"0% YOY"}
              change={"increase"}
            /> */}

            <DashboardCard
              title={"Waste Diversion Rate"}
              subHeading={
                "Percentage of waste diverted from landfills through recycling or reuse."
              }
              value={`${fixedPercentage(
                dashboardData?.waterDiversion?.diversionRate ?? 0
              )}%`}
              changeValue={`${fixedPercentage(
                dashboardData?.waterDiversion?.yoyChange ?? 0
              )}% YOY`}
              change={
                (dashboardData?.waterDiversion?.yoyChange ?? 0) > 0
                  ? "increase"
                  : "decrease"
              }
            />
          </div>

          {/* Graphs Section */}
          <div className={styles.graphsSection}>
            {/* First Graph Card - Total GHG Emissions */}
            <div className={styles.graphCard}>
              <p className={styles.graph_heading}>
                Total GHG Emissions (tCO2e):{" "}
                <span className={styles.graph_span}>
                  {emissionType === "Annual"
                    ? formatNumberCommaSeparated(ghgTotal?.oneYearTotal)
                    : formatNumberCommaSeparated(ghgTotal?.tenYearTotal)}{" "}
                </span>
              </p>
              <div
                className={styles.scopeSection}
                style={{ padding: 0, width: "102%", marginLeft: "-1%" }}
              >
                <div className={`${styles.scopeItem} ${styles.yearFilter}`}>
                  <select
                    name="month"
                    id="month"
                    value={emissionType}
                    onChange={(e) => setEmissionType(e.target.value)}
                    className={styles.heading_select_month}
                  >
                    {["Annual", "Year On Year"].map((m) => (
                      <option key={m} value={m}>
                        {m}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <LineChart
                dataset={emissionType === "Annual" ? annualdataset : yoydataset}
                labels={
                  emissionType === "Annual"
                    ? monthSort
                    : overviewData?.scope1?.scope1Last10YearData?.map(
                        (d) => d.year
                      )
                }
                display={true}
              />
            </div>

            {/* Second Graph Card - Renewable Energy Consumption */}
            {/* <div className={styles.graphCard}>
              <div className={styles.graphCardiv}>
                <div className={styles.graphcardvalue}>
                  <p className={styles.graph_heading}>
                    Renewable Energy Consumption:{" "}
                    <span className={styles.graph_span}>30% </span>
                    <span>
                      (+10% YOY{" "}
                      <img
                        src={1 > 2 ? increase : decrease}
                        alt="trend"
                        style={{ width: "18px" }}
                      />
                      )
                    </span>
                  </p>
                </div>
              </div>

              <div className={styles.scopeSection}>
                <ScopeItem color="#FFBB33" label="Industry Benchmarks" />
                <ScopeItem color="#0066E7" label="Our Consumption" />
                <div className={`${styles.scopeItem} ${styles.yearFilter}`}>
                  <Select
                    size="small"
                    fullWidth
                    sx={{ height: "32px" }}
                    value={energyYear}
                    onChange={(e) => setEnergyYear(e.target.value)}
                  >
                    {years.map((item, index) => (
                      <MenuItem key={index} value={item}>
                        {item}
                      </MenuItem>
                    ))}
                  </Select>
                </div>
              </div>
              <div>
                <BarChart datasets={barCharDataSet} labels={monthSort} />
              </div>
            </div> */}
          </div>
        </>
      )}
    </div>
  );
};

export default Environment;
